export default __webpack_public_path__ + "static/media/nilgiri.f5d2b174.jpg";